import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Button, Spinner } from "reactstrap";

import Sidebar from "./Sidebar";
import DataPengguna from "./DataPengguna";
import WelcomeDashboard from "./WelcomeDashboard";
import InternSetting from "../Internship/InternSetting";
import InternshipApplicants from "../Internship/InternshipApplicants";
import InternDashboard from "../Internship/InternDashboard";
import FormPageVerification from "../Verification/FormPageVerification";
import AllVerifications from "../Verification/AllVerifications";

// Wisuda UPI YPTK
import PembekalanWisuda from "../WisudaUpiYptk/PembekalanWisuda";
import FotoWisudaList from "../WisudaUpiYptk/FotoWisudaList";

import "bootstrap/dist/css/bootstrap.min.css";
import "./Dashboard.css";

const Dashboard = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [activeTab, setActiveTab] = useState(localStorage.getItem("activeTab") || "welcome"); // Ambil dari localStorage
  const [sidebarExpanded, setSidebarExpanded] = useState(true);
  const navigate = useNavigate();

  // Pindahkan logika pengecekan token ke fungsi terpisah
  const checkAuth = useCallback(async () => {
    const token = localStorage.getItem("token");

    if (!token) {
      console.warn("Token tidak ditemukan, mengalihkan ke login...");
      navigate("/admin/login");
      return;
    }

    try {
      const response = await fetch("https://app.rlagency.id/api_admin/validate-token.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ token }),
      });

      if (!response.ok) {
        throw new Error("Server error, unable to validate token");
      }

      const data = await response.json();
      if (!data.success) {
        throw new Error(data.message);
      }

      setIsLoading(false); // Hanya set loading ke false jika token valid
    } catch (error) {
      console.error("Kesalahan saat validasi token:", error);
      localStorage.removeItem("token");
      navigate("/admin/login");
    }
  }, [navigate]);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  const toggleTab = useCallback(
    (tab) => {
      if (activeTab !== tab) {
        setActiveTab(tab);
        localStorage.setItem("activeTab", tab); // Simpan ke localStorage
      }
    },
    [activeTab]
  );

  const toggleSidebar = () => {
    setSidebarExpanded(!sidebarExpanded);
  };

  // Menambahkan Spinner saat loading
  if (isLoading) {
    return <Spinner color="primary" />;
  }

  return (
    <Container fluid>
      <Row className="g-0">
        <Button
          color="primary"
          className="sidebar-toggle d-md-none"
          onClick={toggleSidebar}
        >
          {sidebarExpanded ? "Sembunyikan Sidebar" : "Tampilkan Sidebar"}
        </Button>

        <div className={`sidebar-container ${sidebarExpanded ? "expanded" : ""}`}>
          <Sidebar toggleTab={toggleTab} activeTab={activeTab} />
        </div>

        <div className={`content-container ${sidebarExpanded ? "with-sidebar" : "no-sidebar"}`}>
          <div className="content-panel">
            {activeTab === "welcome" && <WelcomeDashboard />}
            {activeTab === "data" && <DataPengguna />}
            {activeTab === "internsetting" && <InternSetting />}
            {activeTab === "internapplicants" && <InternshipApplicants />}
            {activeTab === "interndashboard" && <InternDashboard />}
            {activeTab === "verify" && <FormPageVerification />}
            {activeTab === "allVerify" && <AllVerifications />}
            {activeTab === "pembekalan" && <PembekalanWisuda />}
            {activeTab === "fotoWisuda" && <FotoWisudaList />}
          </div>
        </div>
      </Row>
    </Container>
  );
};

export default Dashboard;
